import { createContext, useContext, useEffect, useState, useCallback } from "react";

const STORAGE_KEY = "oplyx_theme_v2"; // v2: light is the default after rebrand confirmation
const ThemeCtx = createContext({ theme: "dark", setTheme: () => {}, toggle: () => {} });

function readStored() {
  if (typeof window === "undefined") return "light";
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === "dark" || v === "light") return v;
  } catch (_) { /* ignore */ }
  return "light"; // OPLYX default — light with brand aesthetic
}

function applyTheme(theme) {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  root.dataset.theme = theme;
  // Also toggle Tailwind's `.dark` class so existing dark: utilities keep working
  root.classList.toggle("dark", theme === "dark");
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(readStored);

  useEffect(() => { applyTheme(theme); }, [theme]);

  const setTheme = useCallback((t) => {
    setThemeState(t);
    try { localStorage.setItem(STORAGE_KEY, t); } catch (_) { /* ignore */ }
  }, []);

  const toggle = useCallback(() => {
    setTheme(theme === "dark" ? "light" : "dark");
  }, [theme, setTheme]);

  return <ThemeCtx.Provider value={{ theme, setTheme, toggle }}>{children}</ThemeCtx.Provider>;
}

export function useTheme() {
  return useContext(ThemeCtx);
}

export default ThemeProvider;
